import { Icon } from "@zapier/zinnia-icons";
import { Text } from "@zapier/design-system";
import styles from "./DragDropOverlay.module.css";

export function DragDropOverlay() {
  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <Icon name="actionDownload" size="large" color="UiPrimaryStronger" />
        <Text type="ParagraphHeader3" color="TextLink">
          Drop image(s) to place on your canvas
        </Text>
      </div>
    </div>
  );
}
